import { jsxs, jsx } from "react/jsx-runtime";
const IconAttachmentSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.033 4c-.662 0-1.296.263-1.764.73l-8.026 8.027a4.243 4.243 0 0 0 6 6l8.026-8.026a1 1 0 0 1 1.414 1.415l-8.026 8.026a6.243 6.243 0 1 1-8.828-8.83l8.026-8.025a4.495 4.495 0 1 1 6.357 6.357L11.177 17.7a2.749 2.749 0 0 1-3.886-3.886l7.415-7.406a1 1 0 0 1 1.414 1.415l-7.414 7.405a.75.75 0 0 0 .528 1.277.748.748 0 0 0 .529-.22l8.035-8.025A2.497 2.497 0 0 0 16.033 4Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  IconAttachmentSvg
};
